import { useMutation } from '@tanstack/react-query';
import { changePassword } from '../services/idaas/user';

interface ChangePasswordVariables {
  oldPassword: string;
  newPassword: string;
}

export const useChangePassword = () => {
  return useMutation<void, Error, ChangePasswordVariables>({
    mutationFn: async ({ oldPassword, newPassword }: ChangePasswordVariables) => {
      return changePassword({ oldPassword, newPassword });
    },
  });
};
